/**
 * 채용 페이지
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Briefcase, Mail } from "lucide-react";

export default function Careers() {
  return (
    <>
      <Seo
        title="채용 — OZK News"
        description="OZK News와 함께 성장할 인재를 찾습니다."
        path="/careers"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">채용</h1>
            <p className="text-lg text-muted-foreground">
              OZK News와 함께 성장할 인재를 찾습니다
            </p>
          </div>

          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Briefcase className="w-5 h-5" />
                채용 안내
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                OZK News는 호주 한인 커뮤니티를 위한 플랫폼을 함께 만들어갈
                열정적인 인재를 찾고 있습니다.
              </p>
              <div className="mt-6 p-4 bg-muted rounded-lg">
                <p className="font-semibold mb-2">지원 방법</p>
                <p className="text-muted-foreground mb-4">
                  이메일로 이력서와 자기소개서를 보내주세요.
                </p>
                <div className="flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  <a
                    href="mailto:ozknews.com@gmail.com"
                    className="text-brand-primary hover:underline"
                  >
                    ozknews.com@gmail.com
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </>
  );
}
